<script>
export default {
  name: "DidoTextTruncate",
};
</script>

<script setup>
import { computed, ref } from "vue";
import { pause } from "../../utils";

// define Props
const props = defineProps({
  text: { type: String, required: false, default: "" },
  length: { type: Number, required: false, default: 100 },
  textClasses: { type: Array, required: false, default: () => [] },
  linkClasses: { type: Array, required: false, default: () => [] },
});

// define Reactive Data
const show = ref(false);

// define ref for toggle elements
const expandEl = ref(null);
const collapseEl = ref(null);

const isNecessary = computed(() => props.text.length >= props.length);

// define methods
const truncate = (val) =>
  val ? val.toString().substring(0, props.length || 100) + "..." : "";
const toggle = async () => {
  show.value = !show.value;
  await pause(1);
  const node = expandEl.value || collapseEl.value;
  node.scrollIntoView({ block: "center", behavior: "auto" });
};
const nl2br = (val) => (val ? val.toString().replace(/\n/g, "<br />") : "");
</script>

<template>
  <div>
    <!-- Truncate Text -->
    <template v-if="!show && isNecessary">
      <span :class="props.textClasses" v-html="nl2br(truncate(props.text))" />
      <a
        v-if="props.text.length >= props.length"
        ref="expandEl"
        :class="props.linkClasses"
        @click.stop.prevent="toggle()"
        >voir plus</a
      >
    </template>
    <!-- Show All Text -->
    <template v-else>
      <span :class="props.textClasses" v-html="nl2br(props.text)" />
      <a
        v-if="isNecessary"
        ref="collapseEl"
        :class="props.linkClasses"
        @click.stop.prevent="toggle()"
        >replier</a
      >
    </template>
  </div>
</template>
